import type * as React from 'react';

export default class MenuAction {
    constructor(
        public readonly name: string,
        public readonly action: (event?: React.MouseEvent<HTMLElement>) => void,
        public readonly isPremium: boolean = false
    ) { 
        this.name = name;
        this.action = action;
        this.isPremium = isPremium;
    }
}
